import { render } from "./Register.vue?vue&type=template&id=3ca9f6c3&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=3ca9f6c3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca9f6c3"]])

export default __exports__